module.exports = __webpack_public_path__ + "static/media/feature-quality-leads.134bcb23.png";